import I18n from 'I18n';
import { DateFilterType } from '../constants/filters';
const DATE_FORMAT = 'MMM D, YYYY';
const formatDateRange = (start, end) => {
  return `${start.format(DATE_FORMAT)} – ${end.format(DATE_FORMAT)}`;
};
const formatSingleDate = date => {
  return date.format(DATE_FORMAT);
};
export const getDateRangeDescription = type => {
  switch (type) {
    case DateFilterType.TODAY:
      return formatSingleDate(I18n.moment());
    case DateFilterType.YESTERDAY:
      return formatSingleDate(I18n.moment().subtract(1, 'day'));
    case DateFilterType.LAST_7_DAYS:
      return formatDateRange(I18n.moment().subtract(7, 'days').startOf('day'), I18n.moment());
    case DateFilterType.LAST_30_DAYS:
      return formatDateRange(I18n.moment().subtract(30, 'days').startOf('day'), I18n.moment());
    case DateFilterType.THIS_WEEK:
      return formatDateRange(I18n.moment().startOf('week'), I18n.moment());
    case DateFilterType.THIS_MONTH:
      return formatDateRange(I18n.moment().startOf('month'), I18n.moment().endOf('month'));
    case DateFilterType.LAST_MONTH:
      return formatDateRange(I18n.moment().subtract(1, 'month').startOf('month'), I18n.moment().subtract(1, 'month').endOf('month'));
    case DateFilterType.THIS_QUARTER:
      return formatDateRange(I18n.moment().startOf('quarter'), I18n.moment().endOf('quarter'));
    case DateFilterType.LAST_QUARTER:
      return formatDateRange(I18n.moment().subtract(1, 'quarter').startOf('quarter'), I18n.moment().subtract(1, 'quarter').endOf('quarter'));
    case DateFilterType.YEAR_TO_DATE:
      return formatDateRange(I18n.moment().startOf('year'), I18n.moment());
    case DateFilterType.ALL_TIME:
      return undefined;
    default:
      return undefined;
  }
};